import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  signInWithToken(token) {
    return axiosInstance.post(`/security/authentication/login?token=${token}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  getUserStatus() {
    return axiosInstance.get('/security/authentication/status', {
      cancelToken: getNewCancelToken(),
    });
  },
  setCompany(companyId) {
    return axiosInstance.get(`/security/authentication/setcompany/${companyId}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  logout() {
    return axiosInstance.get('/security/authentication/logout', {
      cancelToken: getNewCancelToken(),
    });
  },
};
